const SITE_URL = 'https://www.gaoyizx.com'
const SOCIAL_IMAGE_URL = `${SITE_URL}/gaoyi-logo.png`

const getOrCreateMeta = (attribute, value) => {
  let element = document.head.querySelector(`meta[${attribute}="${value}"]`)

  if (!element) {
    element = document.createElement('meta')
    element.setAttribute(attribute, value)
    document.head.appendChild(element)
  }

  return element
}

const setMetaContent = (attribute, value, content) => {
  const element = getOrCreateMeta(attribute, value)
  element.setAttribute('content', content)
}

const setCanonicalUrl = (url) => {
  let canonical = document.head.querySelector('link[rel="canonical"]')

  if (!canonical) {
    canonical = document.createElement('link')
    canonical.setAttribute('rel', 'canonical')
    document.head.appendChild(canonical)
  }

  canonical.setAttribute('href', url)
}

const getCanonicalUrl = (path) => {
  const normalizedPath = path === '/' ? '/' : path.replace(/\/+$/, '')
  return new URL(normalizedPath, `${SITE_URL}/`).toString()
}

export const updatePageSeo = (route, i18n) => {
  const seo = route.meta?.seo || {}
  const translate = i18n.global.t
  const locale = i18n.global.locale.value
  const siteName = translate('seo.siteName')
  const translatedTitle = seo.titleKey
    ? translate(seo.titleKey)
    : translate('common.pageTitle')
  const title = seo.fullTitle
    ? translatedTitle
    : `${translatedTitle} - ${siteName}`
  const description = seo.descriptionKey
    ? translate(seo.descriptionKey)
    : translate('seo.defaultDescription')
  const canonicalUrl = getCanonicalUrl(seo.canonicalPath || route.path || '/')
  const ogLocale = locale === 'zh' ? 'zh_CN' : 'en_US'

  document.title = title
  document.documentElement.setAttribute('lang', locale === 'zh' ? 'zh-CN' : 'en')

  setMetaContent('name', 'description', description)
  setMetaContent('name', 'robots', 'index,follow,max-image-preview:large')
  setMetaContent('property', 'og:type', 'website')
  setMetaContent('property', 'og:site_name', siteName)
  setMetaContent('property', 'og:locale', ogLocale)
  setMetaContent('property', 'og:title', title)
  setMetaContent('property', 'og:description', description)
  setMetaContent('property', 'og:url', canonicalUrl)
  setMetaContent('property', 'og:image', SOCIAL_IMAGE_URL)
  setMetaContent('name', 'twitter:card', 'summary')
  setMetaContent('name', 'twitter:title', title)
  setMetaContent('name', 'twitter:description', description)
  setMetaContent('name', 'twitter:image', SOCIAL_IMAGE_URL)
  setCanonicalUrl(canonicalUrl)
}
